import makeRequest from '@justgiving/http-client';
import { convertBase64ToBlob } from '@justgiving/image-editor';
import config from '../config';

const uploadImage = async (base64: string) => {
  try {
    const formData = new FormData();
    formData.append('file', convertBase64ToBlob(base64));
    const res = await makeRequest(config.imageAPIBaseURL, {
      method: 'POST',
      body: formData,
      credentials: 'omit',
      timeoutInMs: config.imageUploadTimeoutInMs,
      headers: {},
    });
    const json = await res.json();
    if (json.success) {
      return json.path;
    }
    throw new Error('failed to upload image');
  } catch (err) {
    throw err;
  }
};

export default uploadImage;
